import React from 'react';
import { Tooltip } from '@mui/material';
import { PLATFORM_MCP_COPY } from '../../constants/platformMcpCopy';
import styles from '../PlatformAdmin/PlatformAdmin.module.scss';

/** "Read only" / "Makes changes" for a Platform MCP tool. */
const ToolAccessBadge = ({ readOnly }) => (
  <Tooltip
    title={readOnly ? PLATFORM_MCP_COPY.readOnlyTip : PLATFORM_MCP_COPY.makesChangesTip}
    arrow
  >
    <span className={`${styles.effBadge} ${readOnly ? styles.info : styles.neutral}`}>
      {readOnly ? PLATFORM_MCP_COPY.readOnly : PLATFORM_MCP_COPY.makesChanges}
    </span>
  </Tooltip>
);

export default ToolAccessBadge;
